import {ConstructorSize} from "../../data";

export const getSizeDimensionsLabel = (size: ConstructorSize | null) => {
    const dimensions = size?.parameters.dimensions || null;

    return dimensions
        ? `ДxШxВ: ${dimensions.length}x${dimensions.width}x${dimensions.height} мм`
        : '';
};
